import styled from "styled-components";

export const StyledSection3 = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 32px;
  padding-top: 32px;
  .section3-container {
    /* margin-top: 32px; */
    width: calc(100% - 22px);
    border-radius: 4px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    background-color: #f0f0f0;
    border: 1px solid #d4d4d4;
    & > button {
      min-width: 68px;
      font-size: 14px;
      outline: none;
      padding: 6px 10px;
      display: flex;
      gap: 4px;
      border: 1px solid #4679cc;
      border-radius: 4px;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .search-btn {
      background-color: #4679cc;
      color: #f0f0f0;
    }
    .download-btn {
      background-color: #fff;
      color: #4679cc;
    }
    .disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
  .line {
    display: block;
    margin: 20px 0;
    width: 100%;
    height: 1px;
    background: #dfdfdf;
    position: relative;
    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      padding: 0 20px;
      font-size: 12px;
      color: #cfcfcf;
    }
  }
`;
